import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SelectField from 'shared-components/reduxForms/fields/SelectField/SelectField';
import TextField from '../../app-main/components/reduxForms/fields/TextField/TextField';
import RequiredLabel from '../../elements-inputs/RequiredLabel';
import { FormattedMessage } from 'react-intl';
import { get, isEmpty } from 'lodash';
import { Tooltip } from '../../elements-tooltip/tooltip-v2';

const AddressFormInputs = ({
  defaultCountry,
  countryOptions,
  selectedCountry,
  formattedDivisions = [],
  displayTooltip = true
}) => {
  return (
    <div className="AddressFormRow flex flex-wrap margin-xl-top">
      <div className="input-container">
        {defaultCountry ?
          <div className="flex flex-basis-100">
            <label className="margin-md-right" htmlFor="billing-country">
              <FormattedMessage id="hosting.billing_address_form.country_label" defaultMessage="Country"/>
            </label>
            {
              displayTooltip &&
              <div className="flex-basis-75">
                <Tooltip
                  placement="top"
                  id="country-info"
                  anchorType="default"
                  hideOnClickAnywhere
                  arrowPlacement={{ left: 10, arrowLeft: 110 }}
                >
                  <FormattedMessage id="hosting.billing_address_form.billing_country_tooltip" defaultMessage="Your billing address must be in the country where your space is located."/>
                </Tooltip>
              </div>
            }
          </div> :
          <RequiredLabel className="label" htmlFor="billing-country">
            <FormattedMessage id="hosting.billing_address_form.country_label" defaultMessage="Country"/>
          </RequiredLabel>
        }
        <Field
          id="billing-country"
          component={SelectField}
          options={countryOptions}
          name="country"
          isDisabled={!!defaultCountry}
          isSearchable={true}
        />
      </div>
      <div className="flex-basis-50" />
      <div className="input-container">
        <RequiredLabel className="label" htmlFor="billing-street">
          {get(selectedCountry, 'labels.address1', <FormattedMessage id="hosting.billing_address_form.street_address_label" defaultMessage="Street address"/>)}
        </RequiredLabel>
        <Field
          id="billing-street"
          component={TextField}
          name="street"
        />
      </div>
      <div className="input-container">
        <label className="label" htmlFor="billing-unit">
          {get(selectedCountry, 'labels.address2', <FormattedMessage id="hosting.billing_address_form.address_2_label" defaultMessage="Address 2"/>)}
        </label>
        <Field
          id="billing-unit"
          component={TextField}
          name="unit"
        />
      </div>
      <div className="input-container">
        <RequiredLabel className="label" htmlFor="billing-city">
          {get(selectedCountry, 'labels.city', <FormattedMessage id="hosting.billing_address_form.city_label" defaultMessage="City"/>)}
        </RequiredLabel>
        <Field
          id="billing-city"
          component={TextField}
          name="city"
        />
      </div>
      {
        !isEmpty(get(selectedCountry, 'zones')) &&
        <div className="input-container">
          <RequiredLabel className="label" htmlFor="billing-state">
            {get(selectedCountry, 'labels.zone')}
          </RequiredLabel>
          <Field
            component={SelectField}
            options={formattedDivisions}
            name="state"
            defaultValue={formattedDivisions[0].value}
          />
        </div>
      }
      <div className="input-container">
        <RequiredLabel className="label" htmlFor="billing-zip">
          {get(selectedCountry, 'labels.postalCode', <FormattedMessage id="hosting.billing_address_form.postal_code" defaultMessage="Postal Code"/>)}
        </RequiredLabel>
        <Field
          id="billing-zip"
          component={TextField}
          name="zip"
        />
      </div>
    </div>
  )
}

export default AddressFormInputs;
